<template>
  <div>
     <div class="tabberWarp">
		<div class="warp">
            <router-link to="marketingDaily">
              <span>
                <img v-show="tabActive == 1" src="../../../assets/images/data/yingxiao.png">
                <img v-show="tabActive == 0" src="../../../assets/images/data/yingxiao2.png">
                <div :class="tabActive == 1 ? 'de': 'gren'">销售日报</div>
              </span>
            </router-link>

            <router-link to="rankList" v-if="!isManager">
               <span>
                  <img v-show="tabActive == 0" src="../../../assets/images/data/paihang.png">
                  <img v-show="tabActive == 1" src="../../../assets/images/data/paihang2.png">
                  <div :class="tabActive == 0 ? 'de': 'gren'">排行榜</div>
               </span>
            </router-link>

            <router-link to="../../order/orderList?isManager=1" v-if="isManager">
               <span>
                  <img v-show="tabActive == 0" src="../../../assets/images/data/paihang.png">
                  <img v-show="tabActive == 1" src="../../../assets/images/data/paihang2.png">
                  <div :class="tabActive == 0 ? 'de': 'gren'">订单列表</div>
               </span>
            </router-link>

		</div>
	</div>
  </div>
</template>

<script>
    //import heading from '@/components/dataManageHeading'
    export default {
        name: "productIndex",
        props:{
           tabActive: Number
        },
        data() {
            return {
                isManager:true
            }
        },
        created() {

        },
        methods: {

        },
    }
</script>

<style scoped lang="scss">
   .gren{
       color: #1FC581
   }
   .de{
       color: #999999
   }
   img{
     display: block;
     margin: 0 auto;
   }
   .warp{
		width: 100%;
		border-top: 1px solid #eee;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: space-around;
		font-size: .22rem;
        color: #919BA6;
	}
	.warp img{
		width: .56rem;
		height: .56rem;
        vertical-align: middle;
	}
	.tabberWarp{
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		padding-bottom: .05rem;
		background: #fff;
        z-index: 99;
     }
</style>



// WEBPACK FOOTER //
// index.vue?000293fc